export default __webpack_public_path__ + "images/Sagittal_View_of_the_Face_dark.a43d6c4ca4fcba81bed9cda4c8ddffca.png";